import React, { useState, useEffect } from "react";
import aboutImage from "@assets/images/about-us/otomol-banner.jpg";
import Header from "@pages/private/Layout/Header";
import Footer from "@pages/private/Layout/Footer";

const AboutUs = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateImage = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
    };

    updateImage(); // Set initial image
    window.addEventListener("resize", updateImage);

    return () => {
      window.removeEventListener("resize", updateImage);
    };
  }, []);

  return (
    <React.Fragment>
      <Header />
      <div className="min-h-screen bg-white">
        {/* Main Content */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl -mt-4 sm:-mt-8 mb-4">
          <div className="row">
            <div className="col-12">
              <h1 className="text-2xl font-bold m-0 pt-8 pb-4">Hakkımızda</h1>
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="relative w-full max-w-4xl mx-auto group">
              <img
                src={aboutImage}
                alt="Hakkımızda"
                loading="lazy"
                className="w-full h-[500px] object-cover object-center rounded-2xl shadow-2xl"
              />

              <div className="mt-3">
                <h4>Cargill Hakkında</h4>

                <p>
                  Cargill; gıda ve tarımsal çözümler sunarak dünyayı güvenli,
                  sorumlu ve sürdürülebilir biçimde beslemeyi hedeflemektedir.
                  160 yılı aşkın köklü deneyimiyle; 70 ülkede, 150.000’den fazla
                  çalışanıyla faaliyet gösteren Cargill; tedarik zincirinin
                  kalbinde yer alarak, yaşam için hayati önem taşıyan ürünleri
                  tedarik etmek, üretmek ve sunmak için çiftçilerle ve
                  müşterilerle ortaklık kurmaktadır.
                </p>
              </div>

              <div className="mt-3">
                <h4>Cargill Türkiye</h4>

                <p>
                  Türkiye’deki faaliyetlerine 1960’lı yıllarda başlayan Cargill,
                  1992’de açılan Türkiye merkez ofisinin yanı sıra Ankara’daki
                  ofisi ile Bursa, Balıkesir, Kocaeli ve Sakarya’da yer alan
                  üretim tesislerinde gıda, biyoendüstriyel ve hayvan besleme ve
                  sağlığı sektörlerinde Türkiye ekonomisine katkı sağlayarak,
                  hayatın her alanına dokunmaktadır. 2014 yılında Orta Doğu ve
                  Kuzey Afrika, 2018’de ise Sahra Altı Afrika’nın eklenmesiyle
                  Orta Doğu, Türkiye ve Afrika’yı (META) içine alan bölgenin
                  yönetim merkezi olarak 700’ü aşkın çalışanıyla faaliyetlerini
                  yürütmektedir.
                </p>

                <p>
                  Türkiye’deki dört fabrikasıyla işletmelerin büyüyebilmesi,
                  toplulukların gelişebilmesi ve tüketicilerin iyi yaşayabilmesi
                  amacıyla müşterilere yaşamın temel ihtiyaçlarını sunmak için
                  yenilikler yapmaktadır. Yerel üretime, uzun vadeli yatırımlara
                  ve tedarik zinciri genelinde ortak değer yaratmaya odaklanan
                  Cargill Türkiye; tedarikinin önemli bir oranını Türkiye’den
                  sağlamakta ve 70 ülkeye ihracat yapmaktadır.
                </p>
              </div>

              <div className="mt-3">
                <h4>Cargill Food Service </h4>

                <p>
                  Cargill Food Solutions, 2014 yılında Turyağ’ın katılmasıyla
                  birlikte Türkiye’de ev dışı tüketim kanalındaki faaliyetlerini
                  güçlendirmiştir. Bugün bitkisel yağlar, krema bazlı ürünler,
                  sıvı şanti ve yerli-yabancı çikolata markalarından oluşan
                  geniş ürün portföyüyle; HoReCa (Hotel, Restaurant, Cafe),
                  pastacılık ve profesyonel mutfak segmentlerinde iş ortaklarına
                  kaliteli, sürdürülebilir ve katma değerli çözümler
                  sunmaktadır.
                </p>
              </div>

              <div className="mt-3">
                <h4>Cargill Gurme</h4>

                <p>
                  Cargill Gurme, ustalığa değer katan markaların buluşma
                  noktasıdır. Profesyonel mutfaklar için özenle seçilmiş
                  ürünleri, teknik uzmanlığı ve global deneyimi bir araya
                  getirerek şeflerin ve ustaların en iyi sonuçlara ulaşmasını
                  destekler. Bu ekosistemin bir parçası olan Gurme Club ise,
                  profesyonellerle daha güçlü ve sürdürülebilir bağlar kurmak
                  amacıyla tasarlanmış sadakat platformudur. Gurme Club
                  sayesinde şefler ve işletmeler, ürün kullanımı ve platform
                  üzerindeki etkileşimleriyle puan kazanırken; özel avantajlara,
                  eğitimlere, etkinliklere ve ayrıcalıklı deneyimlere erişim
                  sağlayabilir. Böylece Cargill Gurme, yalnızca ürün sunan bir
                  marka çatısı değil, profesyonellerin gelişimini ve başarısını
                  destekleyen bütünsel bir iş ortağı haline gelir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default AboutUs;
